import { IconButton, Typography } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import React from 'react'
import { BP_PANEL_TEXT } from '../constants'
import { useBestPracticeManagementPanelStyles } from '../styles/useBestPracticeManagementPanelStyles'

interface BestPracticeManagementPanelActionsProps {
    onClose: () => void
}

export const BestPracticeManagementPanelActions = ({
    onClose,
}: BestPracticeManagementPanelActionsProps) => {
    const classes = useBestPracticeManagementPanelStyles()

    return (
        <div className={classes.titleBar}>
            <Typography component="h1" className={classes.title}>
                {BP_PANEL_TEXT.PANEL_TITLE}
            </Typography>
            <IconButton
                size="small"
                onClick={onClose}
                aria-label="Close panel"
                className={classes.closeButton}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </div>
    )
}
